import { EditSubaccountRequest } from 'vopay';
import { api } from '@/services/api.config';

export default function useEditSubAccount() {
  async function editSubAccount(request: EditSubaccountRequest) {
    try {
      const res = await api.editSubaccount(request);
      if (!res.Success) throw new Error(res.ErrorMessage);
      return res;
    } catch (error) {
      console.error(error);
      throw error;
    }
  }

  return { editSubAccount };
}
